module.exports = __webpack_public_path__ + "static/accommodation_background.294214cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Location/accommodation_background.svg
// module id = 698
// module chunks = 213534597649335